import React, { Component } from 'react';
import { Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';

import { StatesArray } from '../constants';

const mapStateToProps = state => ({
  //listing: state.Listing
});

const cssFormControl = "form-control";
const cssErrorInput = "error-input";

class AddressForm extends Component {
  constructor(props) {
    super(props);
  }

  buildDropdown(name, options, placeholder) {
    return (
      <Field
        component="select"
        placeholder={placeholder ? placeholder : ''}
        name={name}
        className={cssFormControl}>
        <option value="" disabled={true}>State</option>
        {options && options.map((v) => { return (<option key={v} value={v}>{v}</option>) })}
      </Field>);
  }

  render() {
    let errors = this.props.errors ? this.props.errors : {};
    let touched = this.props.touched ? this.props.touched : {};
    return (
      <div>
        <div className="fieldgroup">
          <Field
            name="address1"
            type="text"
            placeholder="Address Line 1"
            className={`${cssFormControl} ` + (touched.address1 && errors.address1 ? cssErrorInput : '')}
          />
          <ErrorMessage name="address1" component="div" className="error-message" />
        </div>
        <div className="fieldgroup">
          <Field
            name="address2"
            type="text"
            placeholder="Address Line 2 (Optional)"
            className={cssFormControl}
          />
        </div>
        <div className="fieldgroup">
          <Field
            name="zip"
            type="text"
            pattern="[0-9]*"
            placeholder="ZIP code"
            className={`${cssFormControl} ` + (touched.zip && errors.zip ? cssErrorInput : '')}
          />
          <ErrorMessage name="zip" component="div" className="error-message" />
        </div>
        <div className="fieldgroup row">
          <div className="col-8">
            <Field
              name="city"
              type="text"
              placeholder="City"
              className={`${cssFormControl} ` + (touched.city && errors.city ? cssErrorInput : '')}
            />
            <ErrorMessage name="city" component="div" className="error-message" />
          </div>
          <div className="col-4">
            {this.buildDropdown("state", StatesArray, "State")}
            <ErrorMessage name="state" component="div" className="error-message" />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(AddressForm);
